/**
 * Wire-format schema for `wp/v2/ezdish/{id}/revisions`.
 *
 * WP's revision objects mirror the parent CPT's REST schema, minus
 * fields WP doesn't snapshot (taxonomies, featured_media). For
 * `ezdish` we get title, content, status, modified, and the
 * `crb_dish_price` meta — enough to render a meaningful history line.
 */
import { z } from 'zod'

import type { DishRevision } from '@/entities/dish-revision'
import { htmlToPlain } from '@/shared/lib/html'

const DishRevisionWireSchema = z
  .object({
    id: z.number().int().positive(),
    parent: z.number().int().positive(),
    author: z.number().int().nonnegative().default(0),
    modified_gmt: z.string(),
    title: z.object({ rendered: z.string() }),
    crb_dish_price: z.union([z.string(), z.number()]).optional().default(''),
  })
  .transform(
    (raw): DishRevision => ({
      id: raw.id,
      parentId: raw.parent,
      authorId: raw.author,
      modifiedAt: raw.modified_gmt.endsWith('Z') ? raw.modified_gmt : `${raw.modified_gmt}Z`,
      title: htmlToPlain(raw.title.rendered),
      price: String(raw.crb_dish_price ?? ''),
    }),
  )

export const dishRevisionListWire = z.array(DishRevisionWireSchema)
